'use client';
// Import Modules
import Image from 'next/image';

// People Assets
import Sandeep from '@/assets/images/Employees/Sandeep.jpg';
import Paaji from '@/assets/images/Employees/Paaji.jpg';
import Chirag from '@/assets/images/Employees/Chirag.png';
import Saransh from '@/assets/images/Employees/Saransh.jpg';
import Amarnath from '@/assets/images/Employees/Amarnath.jpeg';
import AbhishekDas from '@/assets/images/Employees/Abhishek.jpg';
import Ritwick from '@/assets/images/Employees/Ritwick.png';
import MuazzZuberi from '@/assets/images/Employees/MuazzZuberi.webp';
import ShikharTyagi from '@/assets/images/Employees/ShikharTyagi.webp';
import SandeepSingh from '@/assets/images/Employees/SandeepSingh.webp';
import RaghavSharma from '@/assets/images/Employees/RaghavSharma.webp';
import PranavJain from '@/assets/images/Employees/PranavJain.webp';
import BanutejaB from '@/assets/images/Employees/BanutejaB.webp';
import ArpitaSingh from '@/assets/images/Employees/ArpitaSingh.webp';
import AneeshPanda from '@/assets/images/Employees/AneeshPanda.webp';
import AkschayaBalaji from '@/assets/images/Employees/AkschayaBalaji.webp';
import LishaKothari from '@/assets/images/Employees/LishaKothari.webp';

// Import Customer Support
import MoinAkhtarMallick from '@/assets/images/Employees/CustomerSupport/MoinAkhtarMallick.webp';
import SagarShashikantShah from '@/assets/images/Employees/CustomerSupport/SagarShashikantShah.webp';
import ShaikSaleem from '@/assets/images/Employees/CustomerSupport/SaleemShaik.webp';
import SantoshTamannaVaddar from '@/assets/images/Employees/CustomerSupport/SantoshTamannaVaddar.webp';
import ShahnazBanu from '@/assets/images/Employees/CustomerSupport/ShahnazBanu.webp';
import SheebaKhan from '@/assets/images/Employees/CustomerSupport/SheebaKhan.webp';
import SimalAhmed from '@/assets/images/Employees/CustomerSupport/SimalAhmed.webp';
import SyedSaif from '@/assets/images/Employees/CustomerSupport/SyedSaif.webp';
import SyedSalahuddinGhaznavi from '@/assets/images/Employees/CustomerSupport/SyedSalahuddin.webp';
import SyedMuzammil from '@/assets/images/Employees/CustomerSupport/SyedMuzammil.webp';
import AnilKumarPS from '@/assets/images/Employees/CustomerSupport/AnilKumarPS.webp';
import SupriyaC from '@/assets/images/Employees/CustomerSupport/SupriyaC.webp';
import MohammedAqib from '@/assets/images/Employees/CustomerSupport/MohammedAqib.webp';
import MohammedZuhairAhsan from '@/assets/images/Employees/CustomerSupport/MohammedZuhairAhsan.webp';
import AkshitSahu from '@/assets/images/Employees/CustomerSupport/AkshitSahu.webp';
import BLikhit from '@/assets/images/Employees/CustomerSupport/BLikhit.webp';

const Team = () => {
  const team = [
    {
      name: 'Sandeep Srinivasan',
      role: 'Chief Information Security Officer',
      profile: Sandeep,
      description:
        'Our in-house security wizard, Sandeep focuses on cyber security for both the internal team as well as the users. His expertise ensures that Trio remains secure from potential threats and malicious activities.',
    },
    {
      name: 'Chirag Maheshwari',
      role: 'Head of Engineering',
      profile: Chirag,
      description: '',
    },
    {
      name: 'Harjot Singh Oberai',
      role: 'Head of Information Technology',
      profile: Paaji,
      description: '',
    },
    {
      name: 'Saransh Agarwal',
      role: 'Head - Risk, Fraud and Payments',
      profile: Saransh,
      description:
        'Saransh leads the Fraud and Risk & Payments charter. In this capacity, he oversees product development and manages fraud prevention strategies to ensure the integrity and security of our payment systems along with overall payment experience.',
    },
    {
      name: 'Raghav Sharma',
      role: 'Engineering, Senior Manager',
      profile: RaghavSharma,
      description: '',
    },
    {
      name: 'Ritwick Bhaduri',
      role: 'KYC, Senior Manager',
      profile: Ritwick,
      description:
        "Ritwick leads the company's KYC product. His primary focus is to ensure strict adherence to KYC norms, while providing users with the best possible experience.",
    },
    {
      name: 'Amarnath Subburaj',
      role: 'Operations Manager - Customer Support',
      profile: Amarnath,
      description:
        'Amarnath is dedicated to enhancing customer experience by providing comprehensive support across all channels, addressing payments, escalations, and app queries with efficiency. He also effectively oversees the customer service operations of the company.',
    },
    {
      name: 'Abhishek Das',
      role: 'Engineering',
      profile: AbhishekDas,
      description:
        'Abhishek Das is one of the top talents in the Tech Team. He takes care of the user experience and ensures that Trio Tech applications are bug-free.',
    },
    {
      name: 'Arpita Singh',
      role: 'Risk & Fraud Ops',
      profile: ArpitaSingh,
      description: '',
    },
    {
      name: 'Mohammed Muazz Zuberi',
      role: 'Product',
      profile: MuazzZuberi,
      description: '',
    },
    {
      name: 'Shikhar Tyagi',
      role: 'Engineering',
      profile: ShikharTyagi,
      description: '',
    },
    {
      name: 'Sandeep Singh',
      role: 'Engineering',
      profile: SandeepSingh,
      description: '',
    },
    {
      name: 'Pranav Jain',
      role: 'Engineering',
      profile: PranavJain,
      description: '',
    },
    {
      name: 'Banuteja B',
      role: 'IT',
      profile: BanutejaB,
      description: '',
    },
    {
      name: 'Aneesh Panda',
      role: 'Engineering',
      profile: AneeshPanda,
      description: '',
    },
    {
      name: 'Akschaya Balaji',
      role: 'Product',
      profile: AkschayaBalaji,
      description: '',
    },
    {
      name: 'Lisha Kothari',
      role: 'Product',
      profile: LishaKothari,
      description: '',
    },
  ];
  const customerSupportTeam = [
    {
      name: 'Sheeba Khan',
      role: 'Team Lead - Customer Support ',
      profile: SheebaKhan,
      description: '',
    },
    {
      name: 'Syed Muzammil',
      role: 'Team Lead - Customer Support ',
      profile: SyedMuzammil,
      description: '',
    },
    {
      name: 'Syed Salahuddin Ghaznavi',
      role: 'Trainer - Customer Support ',
      profile: SyedSalahuddinGhaznavi,
      description: '',
    },
    {
      name: 'Santosh Tamanna Vaddar',
      role: 'Subject Matter Expert - Customer Support',
      profile: SantoshTamannaVaddar,
      description: '',
    },
    {
      name: 'Sagar Shashikant Shah',
      role: 'Subject Matter Expert - Customer Support',
      profile: SagarShashikantShah,
      description: '',
    },
    {
      name: 'Simal Ahmed P',
      role: 'Senior Executive - Customer Support',
      profile: SimalAhmed,
      description: '',
    },
    {
      name: 'Syed Saif',
      role: 'Senior Executive - Customer Support',
      profile: SyedSaif,
      description: '',
    },
    {
      name: 'Shahnaz Banu',
      role: 'Senior Executive - Customer Support',
      profile: ShahnazBanu,
      description: '',
    },
    {
      name: 'Shaik Saleem',
      role: 'Auditor - VKYC',
      profile: ShaikSaleem,
      description: '',
    },
    {
      name: 'Moin Akhtar Mallick',
      role: 'Auditor - VKYC',
      profile: MoinAkhtarMallick,
      description: '',
    },
    {
      name: 'Anil Kumar P S',
      role: 'Senior Team Lead - Customer Support',
      profile: AnilKumarPS,
      description: '',
    },
    {
      name: 'Supriya C',
      role: 'Quality Team Lead - Customer Support',
      profile: SupriyaC,
      description: '',
    },
    {
      name: 'Mohammed Aqib',
      role: 'Subject Matter Expert - Customer Support',
      profile: MohammedAqib,
      description: '',
    },
    {
      name: 'Mohammed Zuhair Ahsan',
      role: 'Subject Matter Expert - Customer Support',
      profile: MohammedZuhairAhsan,
      description: '',
    },
    {
      name: 'Akshit Sahu',
      role: 'Auditor - VKYC',
      profile: AkshitSahu,
      description: '',
    },
    {
      name: 'B Likhit',
      role: 'Auditor - VKYC',
      profile: BLikhit,
      description: '',
    },
  ];

  const teamToShow = team.concat(customerSupportTeam);

  return (
    <div className="flex flex-wrap gap-4 px-4 justify-center w-full">
      {teamToShow.map((item) => (
        <div key={item.name} className="flex items-center justify-center mx-2 rounded-3xl h-[100%]">
          <div className="h-[100%] w-full bg-linear-to-b from-orange-500 to-green-500 p-[0.5px] rounded-3xl">
            <div className="flex h-full w-full items-center bg-white rounded-3xl p-8 flex-col min-h-[360px] min-w-[256px]">
              <Image
                className="rounded-full w-36 h-36 object-cover"
                src={item.profile}
                alt={item.name}
                width={100}
                height={100}
              />
              <h2 className="text-trio-black my-5 font-extrabold w-full max-w-[12rem] text-center">
                {item.name}
              </h2>
              <hr className="bg-black px-2 w-full opacity-100" />
              <p className="text-trio-black my-5 font-semibold w-full max-w-[12rem] text-center">
                {item.role}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Team;
